import * as React from "react";

import MarketDashboard from "../MarketDashboard";

const MarketDashboardPanel: React.FC = () => {
	return <MarketDashboard />;
};

export default MarketDashboardPanel;